<template>
  <div class="container">
    <div class="left-container">
      <div class="logo-container">
        <img src="../../../assets/logo.png" id="logo" style="max-width: 160px; height: auto">
      </div>
      <div class="form-container">
        <form v-on:submit.prevent="submit()" class="form">
          <div class="title">New Password</div>
          <label class="label-login">Password</label>
          <div class="input-wrapper">
            <input v-model="form.password" name="password" class="input input__round input--key" type="password">
          </div>
          <label class="label-login">Confirm password</label>
          <div class="input-wrapper">
            <input
              v-model="form.confirmPassword"
              name="confirmPassword"
              class="input input__round input--key"
              type="password"
            >
          </div>
          <button class="submit" type="submit">Save</button>
        </form>
      </div>
    </div>
    <div class="image"/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "NewPassword",
  data: function() {
    return {
      form: {
        password: "",
        confirmPassword: ""
      }
    };
  },
  methods: {
    ...mapActions(["newPass"]),
    submit() {
      if (this.form.password === this.form.confirmPassword) {
        this.newPass({token: this.$route.query.token, password: this.form.password});
      } else {
        this.$toasted.error('Passwords do not match.', { className: "error-toast big-toast", position: 'top-center' });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.image {
  background-image: url("../../../assets/new-password-background.png");
  height: 100vh;
  width: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.forgot-pass {
  text-decoration: none;
  float: right;
  color: inherit;
  padding-top: 5px;
  font-size: 12px;
}
.remember-me {
  margin-top: 10px;
  font-family: Montserrat-Regular;
}
.submit {
  margin-top: 20px;
  cursor: pointer;
  border-radius: 18px;
  font-family: Montserrat-SemiBold;
  border: none;
  background: #5A78FF;
  color: white;
  padding: 10px 20px;
  outline: none;
  transition: box-shadow .18s ease-in;
}
.submit:hover,
.submit:focus,
.submit:visited,
.submit:active {
  box-shadow: 0 0px 8px rgba(90, 120, 255, 0.75);
}
.input-icon {
  position: absolute;
  left: 10px;
  top: 11px;
}
.input-icon-eye {
  right: 10px;
  cursor: pointer;
  top: 13px;
  &:hover {
    opacity: 0.6;
  }
  position: absolute;
}
.input-wrapper {
  position: relative;
}
.title {
  font-family: Montserrat-SemiBold;
  font-size: 22px;
  margin-bottom: 20px;
}
.label-login {
  margin: 10px 0px;
  background: transparent;
  font-family: Montserrat-Regular;
}
.input {
  border-radius: 15px;
  padding: 10px 40px;
  padding-right: 90px;
  font-family: Montserrat-Regular;
  outline: none;
  border: 1px solid #dfe2e6;
}
.form-container {
  display: flex;
  height: 60%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.form {
  width: fit-content;
  display: flex;
  flex-direction: column;
}
.container {
  width: 100%;
  display: flex;
  height: 100vh;
}
.left-container {
  width: 50%;
  height: 100%;
}
#logo {
  margin-top: 40px;
  margin-left: 50px;
}
.logo-container {
  width: 100%;
}
</style>
